import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LearningHub from './LearningHub';
import ActivityPage from './ActivityPage';
import TeacherDashboard from './TeacherDashboard';
import PasswordGate from './PasswordGate';
import AvatarCreator from './AvatarCreator';
import VocabularyCategories from './VocabularyCategories';
import StorytellingVideo from './StorytellingVideo';

const Dashboard = () => {
  return (
    <PasswordGate>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard/learning-hub-farsi" replace />} />
        <Route path="/learning-hub" element={<Navigate to="/dashboard/learning-hub-farsi" replace />} />
        <Route path="/learning-hub-farsi" element={<LearningHub language="farsi" />} />
        <Route path="/learning-hub-english" element={<LearningHub language="english" />} />
        <Route path="/vocabulary-categories" element={<VocabularyCategories />} />
        <Route path="/storytelling-video" element={<StorytellingVideo />} />
        <Route path="/avatar-creator" element={<AvatarCreator />} />
        <Route path="/activity/:id" element={<ActivityPage />} />
        <Route path="/teacher" element={<TeacherDashboard />} />
        <Route path="*" element={<Navigate to="/dashboard/learning-hub-farsi" replace />} />
      </Routes>
    </PasswordGate>
  );
};

export default Dashboard;